interface PermissionRequestor {
  requestPermission?: () => Promise<"granted" | "denied" | "default">;
}

/**
 * Request iOS 13+ DeviceOrientation/Motion permission. MUST be called inside a user gesture, and
 * (per the WebKit cross-origin fix) from a gesture inside the player iframe itself. A no-op where
 * `requestPermission` doesn't exist (Android, desktop), which is correct.
 */
export async function requestMotionPermission(): Promise<void> {
  const orientation = DeviceOrientationEvent as unknown as PermissionRequestor;
  if (typeof orientation.requestPermission !== "function") return;

  const result = await orientation.requestPermission();
  if (result !== "granted") {
    throw new Error("Motion permission was denied");
  }
}
